import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconRigissSizeS from './IconRigiss_size_s';

const props: CreateIconArguments = {
  l: IconRigissSizeS,
  m: IconRigissSizeS,
  s: IconRigissSizeS,
  xs: IconRigissSizeS,
  name: 'IconRigiss',
  renderType: { l: 'default', m: 'default', s: 'default', xs: 'default' },
  color: 'multiple',
};

export default props;
